import { useSearchFilters } from '../../../../../../common/components/SearchHeader/filters/useSearchFilters';
import { SearchResultPractitioner } from '../../../../../types';

export const usePracticeForSearchLocation = ({
  practices,
  primaryPractice,
}: SearchResultPractitioner) => {
  const [filters] = useSearchFilters();

  const state = filters.location?.state;

  if (state) {
    return practices.find(it => it.address.state === state) ?? primaryPractice;
  }

  const suburb = filters.location?.suburb;

  if (suburb) {
    return practices.find(it => it.address.suburb === suburb.name) ?? primaryPractice;
  }

  return primaryPractice;
};
